import { computed } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';

/**
 * Tracks the labels the current user most recently applied to conversations,
 * persisted per-user in uiSettings, so label pickers can surface them first.
 */
export function useRecentlyUsedLabels() {
  const { uiSettings, updateUISettings } = useUISettings();

  const recentlyUsedLabels = computed(
    () => uiSettings.value?.recently_used_labels || []
  );

  const recordLabelUsage = titles => {
    const used = (Array.isArray(titles) ? titles : [titles]).filter(Boolean);
    if (!used.length) return;
    const next = [
      ...used,
      ...recentlyUsedLabels.value.filter(t => !used.includes(t)),
    ];
    updateUISettings({ recently_used_labels: next });
  };

  /**
   * Returns a copy of the labels sorted by most-recent use first. Labels that
   * were never used keep their incoming (alphabetical) order, after the used ones.
   * @param {Array<{title: string}>} labels
   */
  const sortByRecentUse = labels => {
    const order = recentlyUsedLabels.value;
    return [...labels].sort((a, b) => {
      const aIndex = order.indexOf(a.title);
      const bIndex = order.indexOf(b.title);
      if (aIndex === -1 && bIndex === -1) return 0;
      if (aIndex === -1) return 1;
      if (bIndex === -1) return -1;
      return aIndex - bIndex;
    });
  };

  return { recordLabelUsage, sortByRecentUse };
}
